import React from 'react';
import { i18nIntl } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import Tooltip from '../builder/Tooltip.js';

const Paginator = ({ total_pages, page, goToPage, pages_arr, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const min_pages_to_display = props?.min_pages_to_display ?? 1;

	if(total_pages < min_pages_to_display) return null;

	return (
		<div class="gui_paginator" style={{marginTop:'2em'}}>
			<ul>
				{(total_pages > 10) && (
					<li class={(page == 1) ? 'disabled' : null}>
						<SquaredButton
							icon='knk-go-prev'
							color={(page == 1) ? 'black' : 'blue'}
							_class={{other:'gui_small_icon go_first_page not_bordered_button'}}
							onClick={() => goToPage(1)}
							tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("***Start", 'ucfirst')}</Tooltip>}
							aria-label="Go to first page"
						/>
					</li>
				)}

				<li class={(page == 1) ? 'disabled' : null}>
					<SquaredButton
						icon='knk-arrow-l-big'
						color={(page == 1) ? 'black' : 'blue'}
						_class={{other:'gui_small_icon go_prev_page not_bordered_button'}}
						onClick={() => goToPage(page - 1)}
						tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("previous", 'ucfirst')}</Tooltip>}
						aria-label="Go to previous page"
					/>
				</li>

				{pages_arr.map((pg, p) => {
					const selected = (pg == page) ? true : false;
					let page_label = pg;
					if(total_pages > 10) {
						if(parseInt(page_label) < 10) page_label = `0${page_label}`;
						if(total_pages > 100) {
							if(parseInt(page_label) < 100) page_label = `0${page_label}`;
							if(total_pages > 1000) {
								if(parseInt(page_label) < 1000) page_label = `0${page_label}`;
							}
						}
					}

					return (
						<li key={`page_${p}`} class={'page_number' + ((selected) ? ' selected' : '')}>
							<ActionLink
								onClick={() => goToPage(pg)}
								autotranslate={false}
							>{page_label}</ActionLink>
						</li>
					)
				})}

				<li class={(page == total_pages) ? 'disabled' : null}>
					<SquaredButton
						color={(page == total_pages) ? 'black' : 'blue'}
						icon='knk-arrow-r-big'
						_class={{ other:'gui_small_icon go_next_page not_bordered_button' }}
						onClick={() => goToPage(page + 1)}
						tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("next", 'ucfirst')}</Tooltip>}
						aria-label="Go to next page"
					/>
				</li>

				{(total_pages > 10) && (
					<li class={(page == total_pages) ? 'disabled' : null}>
						<SquaredButton
							color={(page == total_pages) ? 'black' : 'blue'}
							icon='knk-go-next'
							_class={{ other:'gui_small_icon go_last_page not_bordered_button' }}
							onClick={() => goToPage(total_pages)}
							tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("end", 'ucfirst')}</Tooltip>}
							aria-label="Go to last page"
						/>
					</li>
				)}
			</ul>
		</div>
	)
};

export default injectIntl(Paginator);